getExperiment = require 'lib/experiments/simple-test'
PluginButtonView = require 'views/plugin/plugin-button-view'
t = require('views/internal/teacup-with-helpers')()
track = require 'debug/track'
trackUe = require 'debug/trackUe'

template = t.renderable ({ icon, text }) ->
  t.a '.button-link', {
    class: t.classify('card-detail-section-mini-button': getExperiment('minimizedCardBack').get('enabled')),
    title: text,
    href: '#'
  }, ->
    if icon
      t.span '.icon-sm.plugin-icon',
        style: t.stylify
          'background-image': t.urlify "#{ icon }?color=999"
      t.raw ' '
    t.span '.card-detail-section-mini-button-text', -> t.text text

module.exports = class PluginCardButtonView extends PluginButtonView

  render: ->
    @$el.html(template(@pluginButton))
    @

  trackClick: (pluginButton) ->
    track("Card Detail", "Sidebar Plugin Button", pluginButton.text)
    trackUe('card detail', 'opens', 'Papp/scripts/views/plugin/plugin-card-button-view.coffeeower-Up', '', '', 'card-button', pluginButton.idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-button-view.coffee